import http, {download, uploadCfg} from "../../../utils/HttpUtils";
import {message} from "antd";

//库存盘点服务接口
class StockCheckService {
    //新增
    static async insert(data) {
        const apiUrl = "/stock/check/insert";
        return await http.post(apiUrl, data);
    }

    //修改
    static async update(data) {
        const apiUrl = "/stock/check/update";
        return await http.post(apiUrl, data);
    }

    //作废
    static async disable(id) {
        const apiUrl = `/stock/check/disable/${id}`;
        return await http.get(apiUrl);
    }

    //完成
    static async finish(id) {
        const apiUrl = `/stock/check/finish/${id}`;
        return await http.get(apiUrl);
    }


    //分页查询
    static async findPage(data) {
        const apiUrl = "/stock/check/findPage";
        return await http.post(apiUrl, data);
    }

    static async findByIdOrCode(idOrCode) {
        const apiUrl = `/stock/check/findByIdOrCode/${idOrCode}`;
        return await http.get(apiUrl);
    }

    //导出盘点列表
    static async exportCheckList(data) {
        const apiUrl = "/stock/check/export";
        await download(apiUrl, {type: "post", data})
    }

    //导出盘点明细
    static async exportDetail(data) {
        const apiUrl = `/stock/check/detail/export/${data.warehouseId}`;
        await download(apiUrl, {type: "post", data: data})
    }

    //下载盘点明细模板
    static async downloadDetailTpl(data) {
        const apiUrl = "/stock/check/detail/downloadTpl";
        await download(apiUrl, {data})
    }

    //导入盘点明细
    static async importDetail(data) {
    }

    //获取导入配置
    static getImportDetailCfg(cfg) {
        const apiUrl = "/stock/check/detail/import";
        return uploadCfg(apiUrl, cfg);
    }
}

export default StockCheckService;
